import { createSlice } from "@reduxjs/toolkit";
import { getAllActiveFAQs, insertWebLead } from "@/services/contact.services";

interface ContactState {
  loading: boolean;
  error: string;
  FAQList: unknown[];
  submitted: boolean;
}

const initialState: ContactState = {
  loading: false,
  error: "",
  FAQList: [],
  submitted: false,
};

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    resetContactState: (state) => {
      state.submitted = false;
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(insertWebLead.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(insertWebLead.fulfilled, (state) => {
      state.loading = false;
      state.submitted = true;
    });
    builder.addCase(insertWebLead.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAllActiveFAQs.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveFAQs.fulfilled, (state, action) => {
      state.loading = false;
      state.FAQList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveFAQs.rejected, (state, action) => {
      state.loading = false;
      state.FAQList = [];
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default contactSlice.reducer;
export const { resetContactState } = contactSlice.actions;
